import { render } from "./SideNavDrawer.vue?vue&type=template&id=0d5f82d7"
import script from "./SideNavDrawer.vue?vue&type=script&lang=js"
export * from "./SideNavDrawer.vue?vue&type=script&lang=js"

import "./SideNavDrawer.vue?vue&type=style&index=0&id=0d5f82d7&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__